export const LAYOUT_DIALOG_WIDTH = 620;

export const FEEDBACK_URL = 'https://feedback.ankr.com/feature-requests/';
export const DOCS_URL = 'https://www.ankr.com/docs/build-blockchain/overview';
export const WHATS_NEW_URL =
  'https://www.ankr.com/docs/whats-new/#free-apis-via-sign-in';
export const SERVICE_PLANS_COMPARISON_URL =
  'https://www.ankr.com/docs/rpc-service/service-plans/#service-plans-comparison';

export enum Header {
  Default = 'default',
  Sidebar = 'sidebar',
  Mobile = 'mobile',
}

export enum ESettingsNavTab {
  platform,
  swagger,
  general,
  teammates,
  notifications,
}